/**
 * PHQ9Card - PHQ-9 depression screen card (PROD-646 Sprint 3.3).
 *
 * Thin wrapper around `PromCard` bound to the PHQ-9 definition. LOINC
 * 44249-1 (Patient Health Questionnaire 9 item panel). Severity bands
 * per Kroenke, Spitzer, Williams (2001) JGIM 16(9): 606-613.
 *
 * HC3: citation discipline + LOINC source live in `prom-definitions.ts`.
 * HC5: zero em / en dashes anywhere.
 */
import { PromCard, type PromCardProps } from './PromCard';
import { PHQ9_DEFINITION } from './prom-definitions';

export type PHQ9CardProps = Omit<PromCardProps, 'definition'>;

export function PHQ9Card(props: PHQ9CardProps) {
  return <PromCard definition={PHQ9_DEFINITION} {...props} />;
}
